import React from 'react';
import { useChatUi, useMessageContext } from '../ChatContext';
import { sourceThumbUrl } from '../api/config';
import PageImage from './PageImage';
import { sourceLocation } from './CitationChip';

/** Drawing pages (figure: true) in a larger responsive grid; click opens the page viewer. */
export default function FigureGallery({ sources }) {
  const { t } = useChatUi();
  const { openSource, hoveredSourceId, setHoveredSourceId } = useMessageContext();
  if (!sources || !sources.length) return null;
  return (
    <section className="cv-figures" aria-label={t('Figures')}>
      <div className="cv-section-label">
        {t('Figures')}
        <span className="cv-count">{sources.length}</span>
      </div>
      <div className="cv-figures__grid">
        {sources.map((s) => (
          <button
            key={s.id}
            type="button"
            className={`cv-figure${hoveredSourceId === s.id ? ' is-active' : ''}`}
            onClick={() => openSource(s.id)}
            onMouseEnter={() => setHoveredSourceId(s.id)}
            onMouseLeave={() => setHoveredSourceId(null)}
          >
            <PageImage src={sourceThumbUrl(s, 720)}alt={sourceLocation(s)} ratio="4 / 3" fit="contain" className="cv-figure__img" />
            <span className="cv-figure__caption">
              <span className="cv-badge">{s.id}</span>
              <span className="cv-figure__loc">{sourceLocation(s)}</span>
              {(s.section_title || s.title) && <span className="cv-figure__title">{s.section_title || s.title}</span>}
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
